import { formatRevisionNumber } from './formatRevisionNumber';

export function formatTrainingDocumentRevisionLabel(revision: number): string {
  return `Rev. ${formatRevisionNumber(revision)}`;
}
